import { render, staticRenderFns } from "./ItemCollectionDetail.vue?vue&type=template&id=68867b7a&scoped=true&"
import script from "./ItemCollectionDetail.vue?vue&type=script&lang=js&"
export * from "./ItemCollectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68867b7a",
  null
  
)

export default component.exports